module.exports = __webpack_public_path__ + "img/kilo-blue.1691201f.svg";